var _path, _path2, _path3, _ellipse, _g, _path4, _path5, _path6, _g2, _path7, _path8, _g3, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDogProfileFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#dog-profile-filled_svg__a)"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#44BBD3",
  d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F1BFC8",
  d: "M13.767 6.627c.747-1.47.923-2.331 2.566-1.541s2.52 1.219 3.276 1.685c.755.467 1.05 1.228.002 1.5-1.048.27-2.895.495-4.044.293.363.65.47 1.37.47 1.37s3.982.744 4.544.84c.562.097.673.488.58 1.029-.143.546-.42 4.774-6.106 4.088.742 3.701.79 5.978.268 9.382s-1.066 10.855-1.066 10.855c1.12.436 1.382.913 1.407 1.22.024.31-.28 1.151-1.835 1.02-1.554-.132-1.848-.974-2.114-1.97-.265-.995-.994-6.951-.994-6.951l-1.224.832s-.137 5.722-.203 6.433c-.042.982.762.823 1.033 1.276.272.453.268 1.214-.747 1.47-1.015.254-1.855.248-2.736-1-.881-1.246-1.431-4.387-1.431-4.387S3.854 36.96 3.27 37.373c1.66.823 1.332 1.956.211 2.2s-2.975.369-5.327-.19c-4.064-1.031-4.242-6.106-4.361-6.83-1.354-7.463 5.62-10.31 9.326-14.661.636-3.117 1.602-8.06 1.861-9.23-.341-2.33-.416-3.024.005-3.741.483-.887 5.69-3.124 6.455-2.682.469.28.554 1.7-1.01 3.851 1.63-.004 3.337.537 3.337.537"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.59 6.886c.166-.235.59-.696.785-.748.195-.051 2.058.955 2.058.955s-.994.535-2.392.5c-.226-.428-.45-.708-.45-.708zM9.827 4.418c-.197.992-1.71 3.297-2.956 3.7-.036-1.31.301-2.075.446-2.278.144-.202 1.925-1.41 2.51-1.422"
})), /*#__PURE__*/React.createElement("mask", {
  id: "dog-profile-filled_svg__b",
  width: 27,
  height: 27,
  x: -2,
  y: -2,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.95,
  cy: 12.929,
  fill: "#44BBD3",
  rx: 12.95,
  ry: 12.929,
  transform: "matrix(-.99915 -.005 -.00501 1.00082 24.492 -1.034)"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#dog-profile-filled_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.465 20.937c.502-1.015 1.423-1.536 2.13-1.082 1.48.861-.204 3.987-3.975 6.683-.57-1.692-2.063-6.925.013-7.298 1.147-.166 1.618.937 1.832 1.696"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#19335A",
  d: "M10.444 6.086c-.83.787-1.997 1.585-2.495 1.798 1.297-.125 3.143-1.773 3.143-1.773zM15.576 8.553a26 26 0 0 0-.857-1.488c1.202.532 1.835 1.565 1.835 1.565a5.5 5.5 0 0 1-.978-.078M20.215 13.676c-.534-.042-2.53-1.424-2.264-1.796.39-.552 1.851-.988 2.915-1.026.313.167.37.503.295.935-.055.207-.128.94-.506 1.736-.154.1-.308.164-.44.151"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.702 10.802c-.105-.59.258-1.148.811-1.246s1.086.301 1.19.89c.105.59-.258 1.148-.811 1.246s-1.086-.3-1.19-.89"
})), /*#__PURE__*/React.createElement("mask", {
  id: "dog-profile-filled_svg__c",
  width: 3,
  height: 3,
  x: 9,
  y: 9,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.703 10.801c-.105-.59.258-1.147.81-1.245.553-.098 1.086.301 1.19.891.106.59-.257 1.148-.81 1.245-.552.098-1.085-.3-1.19-.89"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#dog-profile-filled_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#19335A",
  d: "M10.118 11c-.018-.498.317-.913.749-.928s.798.376.816.874c.019.497-.317.913-.749.928s-.797-.376-.816-.874"
}))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.315 10.213c-.095-.533.234-1.037.734-1.126s.981.272 1.076.805c.094.533-.234 1.037-.734 1.126s-.981-.272-1.076-.805"
})), /*#__PURE__*/React.createElement("mask", {
  id: "dog-profile-filled_svg__d",
  width: 3,
  height: 3,
  x: 13,
  y: 9,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.316 10.213c-.095-.534.233-1.038.732-1.126.5-.089.982.272 1.076.805.095.534-.233 1.038-.732 1.126-.5.088-.982-.272-1.076-.806"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#dog-profile-filled_svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#19335A",
  d: "M13.765 10.427c-.016-.433.275-.795.651-.808s.694.328.71.76c.016.434-.275.795-.651.809-.376.013-.694-.328-.71-.76"
}))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#19335A",
  d: "M14.981 15.867c-1.11-.3-3.413-1.702-4.34-2.721-.085-.094-.24-.027-.226.1.118 1.193.98 3.631 2.467 4.734s1.51-1.028 1.502-1.663a.13.13 0 0 1 .16-.127c.155.034.311.045.424.047a.13.13 0 0 0 .13-.155l-.024-.117a.13.13 0 0 0-.092-.098"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#F4776A",
  d: "M11.273 14.981c1.188-.383 2.263.826 2.263.826.325-.072 1.062-.047 1.447 1.182.384 1.229.371 2.394-.868 2.404s-1.332-1.084-1.422-1.852-.673-2.287-1.42-2.56"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#19335A",
  d: "M14.46 18.076c.17-1.143-.506-2.267-.809-2.459s-1.455-.985-1.738-.766c1.519.795 2.102 1.473 2.547 3.224"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "dog-profile-filled_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12"
})))));
export default SvgDogProfileFilled;